<template>
    <div class="rate-box">
        <div>
            <el-input placeholder="请输入用户ID" clearable v-model="queryParams.userId" @keyup.native.enter="handleSearch"
                      style="width: 300px">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-input placeholder="奖励币种" clearable v-model="queryParams.miningCoin" @keyup.native.enter="handleSearch"
                      style="width: 200px">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-autocomplete class="inline-input"
                             v-model="queryParams.coinType"
                             :fetch-suggestions="querySearch"
                             placeholder="请输入币种"
                             @select="handleSelect"
                             @keyup.native.enter="handleSearch">
                <i class="el-icon-close el-input__icon" slot="suffix"
                   @click="cleanSearchCoin" style="cursor:pointer;">
                </i>
            </el-autocomplete>
            <el-button type="primary" @click="searchRate">搜索</el-button>
        </div>

        <div class="rate-list">
            <el-table class="rate-table" border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="awardList" :row-key="() => Math.random()">
                <el-table-column prop="userId" label="用户ID"></el-table-column>
                <el-table-column prop="coinType" label="挖矿币种"></el-table-column>
                <el-table-column prop="miningCoin" label="奖励币种"></el-table-column>
                <el-table-column prop="validAmount" label="有效数量" show-overflow-tooltip></el-table-column>
                <el-table-column prop="awardAmount" label="奖励数量" show-overflow-tooltip></el-table-column>
                <el-table-column prop="status" label="状态" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 1">已发放</span>
                        <span v-if="scope.row.status == 0">未发放</span>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{scope.row.createTime | moment}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="修改时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.updateTime | moment}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination style="margin-top: 30px"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :current-page="queryParams.page"
                           :page-sizes="[10, 20, 50, 100]"
                           :page-size="queryParams.size"
                           layout="total, sizes, prev, pager, next, jumper"
                           :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import '../store';
    import api from '../api';

    export default {
        name: 'AwardList',
        data() {
            return {
                awardList: [], //数据列表
                total: 0, //总条数
                queryParams: { //查询参数
                    page: 1,
                    size: 10,
                    coinType: "",
                    userId: "",
                    miningCoin: ""
                },
                coinTypes: [],
            }
        },
        methods: {
            getUserAwardlist(query) {
                api.getUserAwardlist(query).then(({data}) => {
                    this.awardList = data.list;
                    this.total = data.totalCount;
                });
            },
            searchRate() {
                this.getUserAwardlist(this.queryParams);
            },
            getAllSupportCoin() {
                api.getAllSupportCoin().then(({data}) => {
                    this.coinTypes = data;
                });
            },
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.getUserAwardlist(this.queryParams);
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.getUserAwardlist(this.queryParams);
            },
            querySearch(queryString, cb) {
                var results = [];
                var coinList = this.coinTypes;
                results = queryString ? coinList.filter(this.createFilter(queryString)) : coinList;
                results = results.map((v, i, arr) => {
                    return {
                        value: v
                    }
                });
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                let tempData = this.coinTypes;
                return (tempData) => {
                    return (tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            cleanSearchCoin() {
                this.queryParams.coinType = '';
            },
            handleSearch() {
                this.queryParams.page = 1;
                this.getUserAwardlist(this.queryParams);
            },
            handleSelect() {
            },
            reflashData(){
                this.getAllSupportCoin();
                this.getUserAwardlist(this.queryParams);
            }
        },
        created() {
            // this.getAllSupportCoin();
            // this.getUserAwardlist(this.queryParams);
        }
    };
</script>

<style lang="less" scoped>
    .rate-box {
        .rate-list {
            border: 1px solid #f2ece2;
            clear: both;
            width: 100%;
            .rate-table {
                margin-top: 30px;
            }
        }
    }
</style>
